var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"f8663306ad4616748a19c7ac95fa182085ae693f"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["birsel-uckun@binbircare"]={id:"f8663306ad4616748a19c7ac95fa182085ae693f"};
      